import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Clock, LogOut, Ticket, Settings, X } from 'lucide-react';

const Sidebar = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const navItems = [
    { name: 'Dashboard', path: '/dashboard', icon: <LayoutDashboard size={20} /> },
    { name: 'Clientes', path: '/clientes', icon: <Users size={20} /> },
    { name: 'Sesiones', path: '/sesiones', icon: <Clock size={20} /> },
    { name: 'Bonos', path: '/bonos', icon: <Ticket size={20} /> },
    { name: 'Administración', path: '/admin', icon: <Settings size={20} /> },
  ];


  return (
    <aside className={`
      fixed inset-y-0 left-0 z-50 w-64 bg-stone-900 text-stone-100 flex flex-col pt-6 flex-shrink-0 
      transition-transform duration-300 ease-in-out
      lg:relative lg:translate-x-0
      ${isOpen ? 'translate-x-0 shadow-2xl' : '-translate-x-full'}
    `}>
      <div className="px-6 mb-10 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-amber-500 flex items-center justify-center font-bold text-stone-900">
            SP
          </div>
          <h1 className="text-2xl font-semibold tracking-tight text-amber-50 lg:block hidden">Sol Planet</h1>
        </div>
        <button className="lg:hidden text-stone-400 hover:text-white" onClick={() => setIsOpen(false)}>
          <X size={24} />
        </button>
      </div>
      
      <nav className="flex-1 px-4 space-y-2">
        {navItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 ${
                isActive 
                  ? 'bg-amber-500/10 text-amber-500 font-medium' 
                  : 'text-stone-400 hover:bg-stone-800 hover:text-stone-200'
              }`
            }
          >
            {item.icon}
            {item.name}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 mt-auto">
        <button 
          onClick={handleLogout}
          className="flex items-center gap-3 px-3 py-2.5 w-full rounded-xl text-stone-400 hover:bg-stone-800 hover:text-red-400 transition-all duration-200"
        >
          <LogOut size={20} />
          <span>Cerrar Sesión</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
